module.exports = __webpack_public_path__ + "static/media/quill_attachment.468127c9.svg";